import Service from "@/services/Service";
const baseurl = '/api/citologia/resultado';

export default {
    store(data){
        return Service.post(`${baseurl}/store`, data);
    }
}